import React from 'react';
import { StyledIconStatusPositive, StyledIconStatusWarning,  StyledIconStatusNegative, StyledIconCheckCircle, StyledIconStatusInformation } from '../components/OrderHistoryDashboard/styled';
// Adjust the path as needed

const StatusIndicatorLocal = (status :any) => {
  switch (status.status) {
    case 'Success':
      return <StyledIconStatusPositive />;
    case 'Failed':
      return <StyledIconStatusNegative/>;
    case 'In-Progress':
      return <StyledIconStatusInformation />;
    case 'Partial Success':
      return <StyledIconStatusWarning/>
    default:
      return null; // Or return a default icon/component if needed
  }
};

export default StatusIndicatorLocal;
